import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { DnBtnModule } from '../buttons/dn-btn/dn-btn.module';
import { MatButtonModule } from '@angular/material/button';
import { DnPrimaryBtnModule } from '../dn-primary-btn/dn-primary-btn.module';
import { MatIconModule } from '@angular/material/icon';
import { DnDialogContainerComponent } from './dn-dialog-container/dn-dialog-container.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DnCustomTooltipComponent } from './dn-custom-tooltip/dn-custom-tooltip.component';
// import { DnGhostBtnModule } from '../buttons/dn-ghost-btn/dn-ghost-btn.module';

@NgModule({
  declarations: [DnDialogContainerComponent, DnCustomTooltipComponent],
  imports: [
    CommonModule,
    // DnBtnModule,
    MatButtonModule,
    DnPrimaryBtnModule,
    MatIconModule,
    MatDialogModule,

    // DnGhostBtnModule
  ],
  exports: [DnDialogContainerComponent],
})
export class DnDialogsModule {}
